import React, { useState } from 'react';
import { QUERIES } from '../../api/queries';
import { useQuery } from '@apollo/react-hooks';
import { Table, Spin, Row, Col } from 'antd';

const OrderLogTypeSettings = props => {

  const [orderLogTypes, setOrderLogTypes] = useState(null);

  const { loading, error, refetch } = useQuery(QUERIES.ORDER_LOG_TYPES, {
    onCompleted: res => {
        setOrderLogTypes(res.orderLogTypes);
    }
  });

  const columns = [
    {
      title: 'Type',
      render: record => record.name,
      key: record => record.id+"Name",
    },
    {
      title: 'Code',
      render: record => record.code,
      key: record => record.id+"Code",
    }
  ];

  if (!loading && !error && !!orderLogTypes) {
    return (
      <div>
        <Row type='flex' justify='center'>
          <Table
            rowKey={record => record.id}
            style={{ width: '80vw', margin: 16 }}
            dataSource={orderLogTypes}
            columns={columns}
          />
        </Row>
      </div>
    );
  }

  return (
    <div>
      <Row type='flex' justify='center'>
        <Col span={24}>
          <Spin size='large' />
        </Col>
      </Row>
    </div>
  );

};

export default OrderLogTypeSettings;